module.exports = __webpack_public_path__ + "img/33.ce44b2b4.jpg";